import { createFileRoute } from '@tanstack/react-router';
import { ImportPage } from '@/features/import/import-page';

export const Route = createFileRoute('/w/$workspaceId/settings/import')({ component: ImportPage });
